<script lang="ts">
	import Fa from 'svelte-fa';
	import { faRepeat } from '@fortawesome/free-solid-svg-icons';
	interface Props {
		repeat: boolean | undefined;
		large?: boolean;
		onclick?: (event: MouseEvent) => void;
	}

	let { repeat, large = false, onclick }: Props = $props();
	let classBig = large ? 'btn-icon-lg' : '';
	// svelte-fa ^4 IconSize excludes empty string; use `undefined` for default size.
	const size: '1.5x' | undefined = large ? '1.5x' : undefined;
	let classOn = $derived(repeat ? 'bg-primary-500/80 dark:bg-primary-500/40' : 'bg-primary-500');
	let buttonClasses = $derived(['btn-icon', 'text-white dark:text-white', classBig, classOn]);
</script>

<button class={buttonClasses.join(' ')} {onclick} title={repeat ? 'Play Once' : 'Loop'}>
	<Fa icon={faRepeat} spin={repeat} {size} />
</button>
